import Vue from 'vue'
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';

Sentry.init({
    dsn: 'https://a0579ad82ba5452983e8978cd2c365ed@sentry.io/1814286',
    integrations: [new Integrations.Vue({ Vue, attachProps: true })],
});
console.log(Sentry)

// import * as Sentry from '@sentry/browser';

// Sentry.init({ dsn: 'https://a0579ad82ba5452983e8978cd2c365ed@sentry.io/1814286' });
